import buildAbilityForUser from '@shipbob/rbac'
import { store } from '@/store'

export class MerchantPermissions {
  constructor (abilities) {
    this._abilities = abilities
  }

  static create (permissions = []) {
    // user by merchant app
    this._abilities = buildAbilityForUser(permissions)
    // useful in MFEs since they already have access to parent store
    store.commit('user/setAbilities', this._abilities)
  }

  static can (action, subject) {
    return this?._abilities?.can(action, subject)
  }
}
